





















































































































import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";
import SystemConst from "@/config/const";
import "firebase/auth";

@Component
export default class Header extends Vue {
  drawerFlg = false;
  loginFlg = false;
  salonUrl = process.env.VUE_APP_SALON_ENDPOINT;

  get getUserName(): string {
    const user = this.$store.state.auth.user;
    if (user.name) {
      return user.name.trim();
    } else {
      return "";
    }
  }

  get getHeaderUrl(): string {
    return this.$store.state.headerUrl;
  }

  get getSalonName(): string {
    return this.$store.state.salonName;
  }

  openDrawerMenu() {
    this.drawerFlg = true;
  }

  closeDrawerMenu() {
    this.drawerFlg = false;
  }

  public created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user && this.$store.getters.isLogin) {
        this.loginFlg = true;
      } else {
        this.loginFlg = false;
      }
    });
  }

  public updated() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user && this.$store.getters.isLogin) {
        this.loginFlg = true;
      } else {
        this.loginFlg = false;
      }
    });
  }

  gotoSalonDetail() {
    const salon_id = this.$store.getters.salonId
    if (this.$route.name === "SalonDetail") {
       this.$router.go(0);
    } else {
      this.$router.push({ name: "SalonDetail", params: { salon_id: salon_id }});
    }
  }
}
